<div class="items-center flex gap-4">
  <a *ngFor="let item of socialNetworks$ | async" [href]="item.href" target="_blank">
    <img [src]="item.src" [alt]="item.alt | translate" class="w-14" />
  </a>
  <ng-content></ng-content>
</div>
